var map = {
	"./test 1.png": 24562,
	"./test 10.png": 54819,
	"./test 11.png": 72134,
	"./test 12.png": 67931,
	"./test 13.png": 57081,
	"./test 2.png": 26496,
	"./test 3.png": 55925,
	"./test 4.png": 16402,
	"./test 5.png": 35671,
	"./test 6.png": 79710,
	"./test 7.png": 32052,
	"./test 9.png": 33198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37555;